<template>
    <v-data-table dense hide-default-footer item-key="howz_encrid"
        :headers="getHeaders()" 
        :items="data"
        :disable-pagination=true>

        <template v-slot:item="howz">
        
            <tr>

                <td>{{ $moment(howz.item.created).format("DD-MM-YYYY") }}</td>
                <td>{{ howz.item.howz_wijziging_oms | max_char(50) }}</td>
                <td>{{ howz.item.summary | max_char(50) }}</td>
                <td>{{ howz.item.status_display }}</td>
                <td>{{ howz.item.gebr_naam }}</td>
                <td>
                    <span v-if="!!howz.item.attachments" 
                          v-on:click="attachDocument(`attachments_${itemtype}`, howz.item.howz_encrid, howz.item.change_key)"
                          :class="{'row-pointer': !!howz.item.attachments}">
                        <v-badge color="grey lighten-2" overlap bordered offset-y="27" offset-x="23">
                            <template v-slot:badge>
                                <span>{{ howz.item.attachments }}</span> 
                            </template>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-avatar v-bind="attrs" v-on="on"                                               
                                              size="40" style="margin-top:4px;" class="button-margin-r">
                                        <v-icon small>mdi-paperclip</v-icon>
                                    </v-avatar>
                                </template>
                                <span>{{ itemtype }} {{ howz.item.howz_key }} has {{ howz.item.attachments }} attachments</span>
                            </v-tooltip>
                        </v-badge>
                    </span>
                    <span v-else>
                        <v-btn x-small text icon disabled><v-icon small></v-icon></v-btn>
                    </span>
                </td>
                <td>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small text icon v-bind="attrs" v-on="on"
                                v-on:click="editChangeOne(howz.item.howz_encrid, howz.item.change_key)"
                                class="button-margin-lr gridbutton">
                                <v-icon small>mdi-text-box-edit-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Edit/update {{ itemtype }} {{ howz.item.change_key }} for this booking</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="isAuthorized">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small text icon v-bind="attrs" v-on="on"
                                v-on:click="editChangeAll(howz.item.howz_encrid, howz.item.change_key)"
                                class="button-margin-lr gridbutton">
                                <v-icon small>mdi-pencil-box-multiple-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Edit/update {{ itemtype }} for all bookings </span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small text icon v-bind="attrs" v-on="on"
                                v-on:click="deleteChange(howz.item.howz_encrid, howz.item.change_key)"
                                class="button-margin-l gridbutton">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Delete {{ itemtype }} {{ howz.item.change_key }} from this booking</span>
                    </v-tooltip>
                    <br>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small text icon v-bind="attrs" v-on="on"
                                v-on:click="howz.item.showChanges=!howz.item.showChanges"
                                class="button-margin-lr gridbutton mt-1 mb-1">
                                <v-icon small>mdi-folder-open-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Open overview events for {{ itemtype }} {{ howz.item.change_key }} </span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn x-small text icon v-bind="attrs" v-on="on"
                                v-on:click="addChangeEvent(howz.item.howz_encrid)"
                                class="button-margin-lr gridbutton mt-1 mb-1">
                                <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Add new event for {{ itemtype }} {{ howz.item.change_key }} </span>
                    </v-tooltip>
                </td>
            </tr>
            <tr v-show="howz.item.showChanges">
                <td colspan="9">
                    <viewHwzr 
                        ref="viewHwzr" 
                        :isVisible="howz.item.showChanges" 
                        :howzEncrid="howz.item.howz_encrid" 
                        :change_key="howz.item.change_key" 
                        :data="howz.item.hwzr"
                        @updateField="updateField" 
                        @updateData="updateData" 
                        @executeFunction="executeFunction" 
                        class="pb-3"
                    />
                </td>
            </tr>
        </template>
        
    </v-data-table>

</template>

<script>
    import mxauthorization from '@/mixins/authorization';
    import mxmaxchar from '@/mixins/filtermaxchar';
    import viewHwzr from "@/components/huov/howz/viewHwzr.vue";

    export default {
        mounted(){
            this.getAuthorization("acco-changes-update", "isAuthorized");
        },
        props: {
            data: Array,
            itemtype: String,
        },
        components: {
            viewHwzr,
        },
        mixins: [mxauthorization, mxmaxchar],
        data() {
            return {
                isAuthorized: false,
            }
        },
        methods: {                       
            getHeaders(){
                return [
                    { text: "Created", value: "created", sortable: false, width: "12%"},
                    { text: "Description", value: "howz_wijziging_oms", sortable: false},
                    { text: "Latest development", value: "summary", sortable: false},
                    { text: "Status", value: "status_display", sortable: false},
                    { text: "Assigned to", value: "gebr_naam", sortable: false},
                    { sortable: false, align: "start"},
                    { sortable: false, align: "start", width: "16%"},
                ];
            },
            editChangeAll(howz_encrid, change_key) {
                this.$emit('executeFunction',  [
                    {field: 'function', value: 'update_change_all'},  
                    {field: 'howz_encrid', value: howz_encrid},  
                    {field: 'change_key', value: change_key}
                ]);
            },
            editChangeOne(howz_encrid, change_key) {
                this.$emit('executeFunction',  [
                    {field: 'function', value: 'update_change_one'},  
                    {field: 'howz_encrid', value: howz_encrid},  
                    {field: 'change_key', value: change_key}
                ]);
            },
            deleteChange(howz_encrid, change_key) {
                this.$emit('executeFunction',  [
                    {field: 'function', value: 'delete_change'},  
                    {field: 'howz_encrid', value: howz_encrid},  
                    {field: 'change_key', value: change_key}
                ]);
            },            
            addChangeEvent(howz_encrid) {
                this.$emit('executeFunction',  [
                    {field: 'function', value: 'add_upd_change_event'},  
                    {field: 'howz_encrid', value: howz_encrid},  
                    {field: 'hwzr_encrid', value: ''}
                ]);
            },            
            attachDocument(howz_encrid, change_key) {
                this.$emit('executeFunction',  [
                    {field: 'function', value: 'attachments_change'},  
                    {field: 'howz_encrid', value: howz_encrid},  
                    {field: 'change_key', value: change_key}
                ]);
            },
            executeFunction(data){
                this.$emit('executeFunction',  data);
            },
            updateField(data){
                this[data.field]=data.value;
            },
            updateData(){
                this.$emit('updateData', 'refresh'); // send refresh to parent
            },      
        }
    }

</script>

<style scoped>
    .row-pointer {
      cursor: pointer;
    }
    .button-margin-lr{
        margin-left: 4px;
        margin-right: 4px;
    }
    .button-margin-l{
        margin-left: 4px;
    }  
    .button-margin-r{
        margin-right: 2px;
    }  
    .gridbutton:hover{
        border: 1px solid rgba(169, 169, 169, 1) !important;
    }
</style>